import { NotificationResources } from '../types/notification';

export const getTerminalRoutes = ({ resourceType, resourceTypeId }: IGetPlatformRoutes): string => {
  switch (resourceType) {
    case NotificationResources.Account:
      return '/app/settings/company-profile';
    case NotificationResources.User:
      return `/app/administration/users/${resourceTypeId}`;
    case NotificationResources.Title:
      return '/app/administration/organizational-titles';
    default:
      throw new Error('resource type not recognized for terminal');
  }
};
